(function() { window.GUID_37b9b000_de05_4df6_bced_a19d18a51134 = { getGuid: function() { return "37b9b000-de05-4df6-bced-a19d18a51134"; } }; })();
//declare function GetScoreSheetCodeInMasterSearch();
//declare function GetExtMatchInMasterSearch();
if (CSParameters.IsSportEventAdminSlashManage) {
    MasterPage.MasterSearch.show();
    //#####################    Édition du charte    #################################################################################################
    //###############################################################################################################################################
    var btnEdit = $('#BtnEdit');
    btnEdit.on('click', 'a', function (e) {
        e.preventDefault();
        var url = '';
        var data = {};
        data.ids = selectedFlowBlockId.val();
        if (actualFlowBlockIsBracket == "True") {
            url = CSParameters.RUrl + 'FlowBlockBrackets/EditGridViewFlowBlockBrackets/' + CSParameters.SportEventId;
        }
        else {
            url = CSParameters.RUrl + 'FlowBlockRRBs/EditGridViewFlowBlockRRBs/' + CSParameters.SportEventId;
        }
        let popup = new CompuSport.Controls.Popup();
        popup.GetAndShow({
            PopupId: "",
            Url: url,
            Data: data,
            AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
        });
        popup.OnPosted = function (response) {
            if ($('form', response).length == 0) {
                treeViewDivisionsCharts.Refresh();
                OnFlowBlockChange(treeViewDivisionsCharts.SelectedValue());
            }
        };
        /*
        ShowFormPopup(url, data, null, function (response) {
            if ($('form', response).length == 0) {
                this.dialog('close');
                treeViewDivisionsCharts.Refresh();
                OnFlowBlockChange(treeViewDivisionsCharts.SelectedValue());
            }
        });
        */
    });
    //#####################    Replace entity of flowblock    #################################################################################################
    //###############################################################################################################################################
    var btnReplaceEntity = $('#BtnReplaceEntity');
    btnReplaceEntity.on('click', 'a', function (e) {
        e.preventDefault();
        let data = {
            flowblockid: actualFlowBlockId,
            fromChart: true
            //Post : true
        };
        let popup = new CompuSport.Controls.Popup();
        //si bracket
        if (actualFlowBlockIsBracket == "True") {
            popup.GetAndShow({
                PopupId: "ReplaceEntityPopup",
                Url: CSParameters.RUrl + 'FlowBlockBrackets/ReplaceEntity/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
            });
        }
        else {
            popup.GetAndShow({
                PopupId: "ReplaceEntityPopup",
                Url: CSParameters.RUrl + 'FlowBlockRRBs/ReplaceEntity/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
            });
        }
        //is RRB
        popup.OnPosted = function (result) {
            //Si form length est plus grand que 0, cela indique qu'il ya une erreur et qu'elle doit etre affiché dans la popup, donc, c'Est pourquoi il ne faut pas la fermer
            if ($('form', result).length == 0) {
                UpdateChart(result, true);
            }
        };
    });
    //#####################   Delete all schedules    #################################################################################################
    //###############################################################################################################################################
    var btnDeleteAllSchedules = $('#BtnDeleteAllSchedules');
    btnDeleteAllSchedules.on('click', 'a', function (e) {
        e.preventDefault();
        ExecuteFlowBlockTask("DeleteAllSchedules");
    });
    //#####################   Delete all opponents    #################################################################################################
    //###############################################################################################################################################
    var btnDeleteAllOpponents = $('#BtnDeleteAllOpponents');
    btnDeleteAllOpponents.on('click', 'a', function (e) {
        e.preventDefault();
        ExecuteFlowBlockTask("DeleteAllOpponents");
    });
    //#####################   Change TBA TO BYE    #################################################################################################
    //###############################################################################################################################################
    var btnChangeTbaToBye = $('#BtnChangeTbaToBye');
    btnChangeTbaToBye.on('click', 'a', function (e) {
        e.preventDefault();
        ExecuteFlowBlockTask("ChangeTbaToBye");
        // ShowFormPopup(CSParameters.RUrl + 'FlowBlockBrackets/ChangeTbaToBye/' + CSParameters.SportEventId + '?flowblockids=' + actualFlowBlockId, null, document.GridViewFlowBlockBrackets);
    });
    //#####################   Foward BYE    #################################################################################################
    //###############################################################################################################################################
    var btnForwardBye = $('#BtnForwardBye');
    btnForwardBye.on('click', 'a', function (e) {
        e.preventDefault();
        ExecuteFlowBlockTask("ForwardBye");
    });
    //#####################   Reprint all matchcards    #################################################################################################
    //###############################################################################################################################################
    var btnReprintAllMatchCards = $('#BtnReprintAllMatchCards');
    btnReprintAllMatchCards.on('click', 'a', function (e) {
        e.preventDefault();
        ExecuteFlowBlockTask("ReprintAllMatchCards");
    });
    MasterPage.TxtMasterSearch.on('keyup.chart', function (e) {
        e.stopPropagation();
        var textSearch = $(this).val().toUpperCase();
        CS.Lag(500, function () {
            HiglightBracketBoxesCorrespondingText(textSearch);
        });
    });
    var doNothingOnEnterKeyNotSet = true;
    MasterPage.MasterSearch.on('CSMasterSearch', function (e) {
        if (doNothingOnEnterKeyNotSet) {
            MasterPage.MasterSearch.find('#TxtMasterSearch').data('context').DoNothingOnEnterKey = true;
            doNothingOnEnterKeyNotSet = false;
        }
        if (flowBlocksSearch != null) {
            flowBlocksSearch.hide();
        }
        var keyCodeData = MasterSearchKeyCodeAnalyser.desktop.GetScoreSheetCodeInMasterSearch();
        if (keyCodeData != null) {
            e.stopPropagation();
            e.preventDefault();
            keyCodeData.elementToRefresh = 'chart';
            ShowScorePopup(keyCodeData);
            return;
        }
        var extMatchId = MasterSearchKeyCodeAnalyser.desktop.GetExtMatchInMasterSearch();
        var entityIdIsExtMatchId = false;
        if (extMatchId != null) {
            entityIdIsExtMatchId = true;
        }
        if (bracketBoxes != null) {
            bracketBoxes.removeClass('Hglrdonly');
        }
        var data = {};
        data.entityId = extMatchId != null ? extMatchId : MasterPage.MasterSearch.val();
        data.entityIdIsExtMatchId = entityIdIsExtMatchId;
        if (data.entityId == "") {
            return;
        }
        else {
            HiglightBracketBoxesCorrespondingText(MasterPage.TxtMasterSearch.val().toUpperCase());
        }
        CompuSport.Ajax.Get(CSParameters.ControllerUrl + "GetFindResult/" + CSParameters.SportEventId, data, function (result) {
            $('#TxtMasterSearchAutoCompleteList').hide();
            if (flowBlocksSearch != null) {
                flowBlocksSearch.off('mousedown');
            }
            flowBlocksSearch = $(result);
            flowBlocksSearch.css('z-index', MasterPage.MasterSearch.css('z-index')).css('top', MasterPage.MasterSearch.position().top + MasterPage.MasterSearch.height());
            CS.body.append(flowBlocksSearch);
            flowBlocksSearch.on('mousedown', function (e) {
                var target = $(e.target);
                if (target.hasClass('FlowBlockItemChart')) {
                    var data = {};
                    data.flowBlockId = target.data('id');
                    data.flowBlockType = target.data('type');
                    data.highlightedEntityBaseId = target.data('eid');
                    data.highlightedDrawPosition = '';
                    data.highlightedExtMatchId = extMatchId;
                    data.refreshDropDown = true;
                    CompuSport.Ajax.Get(CSParameters.RUrl + "charts/chart/" + CSParameters.SportEventId, data, function (result) {
                        UpdateChart(result, false);
                    });
                    //OnFlowBlockChange(flowBlockId);
                }
            });
            flowBlocksSearch.slideDown(300, function () {
                if (IsDefined(typeof (CS.docHtml))) {
                    CS.docHtml.trigger('panelopened', flowBlocksSearch[0].id);
                }
            });
        });
    });
}
function ShowScorePopup(data) {
    if (data == null) {
        data = {};
        data.encounterRowId = actualEncounterInfos.EncounterRowId;
        data.elementToRefresh = 'chart';
    }
    CompuSport.Ajax.Get(CSParameters.RUrl + 'Scores/CheckIsNewScoreSheet/' + CSParameters.SportEventId, data, function (response) {
        if (response.isNewScoreSheet) {
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: 'ScorePopup',
                Url: CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (response) {
                UpdateChart(response, true);
            };
        }
        else {
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "ScorePopup",
                Url: CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (response) {
                UpdateChart(response, true);
            };
            //ShowFormPopup(CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId, data, null, function (response, pressedButton) {
            //    if (pressedButton != "EnterKey") {
            //        UpdateChart(response, true);
            //        $(this).dialog('close');
            //    }
            //});
        }
    });
    //ShowFormPopup(CSParameters.RUrl + 'Scores/Popup/' + CSParameters.SportEventId, data, null, function (response, pressedButton) {
    //    if (pressedButton != "EnterKey") {
    //        this.dialog('close');
    //        UpdateChart(response, true);
    //    }
    //});
}
CS.body.on('scoresheetupdated.chart', function (e, response) {
    UpdateChart(response, true);
});
function ExecuteFlowBlockTask(taskName) {
    var data = {};
    data.taskName = taskName;
    data.flowBlockId = actualFlowBlockId;
    data.prePost = true;
    CompuSport.Ajax.Post(CSParameters.ControllerUrl + "ExecuteFlowBlockTask/" + CSParameters.SportEventId, data, function (queryResult) {
        data.prePost = false;
        CompuSport.Controls.Popup.ShowConfirmDialogV2("", queryResult, function () {
            CompuSport.Ajax.Post(CSParameters.ControllerUrl + "ExecuteFlowBlockTask/" + CSParameters.SportEventId, data, function (queryResult) {
                UpdateChart(queryResult, true);
            });
        });
        //var result = ShowConfirmDialog(queryResult);
        //result.Ok = function () {
        //    $.ajaxAntiForgery({
        //        cache: false,
        //        type: "POST",
        //        url: CSParameters.ControllerUrl + "ExecuteFlowBlockTask/" + CSParameters.SportEventId,
        //        data: data,
        //        success: function (queryResult) {
        //            UpdateChart(queryResult, true);
        //        }
        //    });
        //};
    });
}
function RefreshToolBarButtons() {
    if (actualFlowBlockId != undefined && actualFlowBlockId != "" && actualFlowBlockId != "0") {
        EnableDisableFlowBlockButtons(true);
    }
    else {
        EnableDisableFlowBlockButtons(false);
    }
}
function EnableDisableFlowBlockButtons(enable) {
    if (btnEdit != null && btnEdit.length > 0) {
        if (enable) {
            btnReplaceEntity.removeClass('IsDisabled');
            btnEdit.removeClass('IsDisabled');
            btnDeleteAllOpponents.removeClass('IsDisabled');
            btnDeleteAllSchedules.removeClass('IsDisabled');
            btnReprintAllMatchCards.removeClass('IsDisabled');
            if (actualFlowBlockIsBracket == "True") {
                btnForwardBye.removeClass('IsDisabled');
                btnChangeTbaToBye.removeClass('IsDisabled');
            }
            else {
                btnForwardBye.addClass('IsDisabled');
                btnChangeTbaToBye.addClass('IsDisabled');
            }
        }
        else {
            btnReplaceEntity.addClass('IsDisabled');
            btnEdit.addClass('IsDisabled');
            btnDeleteAllOpponents.addClass('IsDisabled');
            btnDeleteAllSchedules.addClass('IsDisabled');
            btnChangeTbaToBye.addClass('IsDisabled');
            btnForwardBye.addClass('IsDisabled');
            btnReprintAllMatchCards.addClass('IsDisabled');
        }
    }
}
function GetEncounterPopup(flowBlockId, encounterNumber) {
    let data = {
        flowBlockId: flowBlockId,
        encounterNumber: encounterNumber
    };
    let popup = new CompuSport.Controls.Popup();
    popup.GetAndShow({
        PopupId: 'GetEncounterPopup',
        Url: CSParameters.RUrl + "Charts/EditEncounter/" + CSParameters.SportEventId,
        Data: data,
        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
    });
    popup.OnPosted = function (result) {
        UpdateChart(result, true);
    };
    //ShowFormPopup(CSParameters.RUrl + "Charts/EditEncounter/" + CSParameters.SportEventId, data, null, function (result) {
    //    $(this).dialog('close');
    //    UpdateChart(result, true);
    //});
}
function FinishBracketMatch() {
    var data = {};
    data.encounterRowId = actualEncounterInfos.EncounterRowId;
    CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/FinishMatch/" + CSParameters.SportEventId, data, function () {
        alert('Match finished!!');
    });
}
function CallMatch() {
    var data = {};
    data.encounterRowId = actualEncounterInfos.EncounterRowId;
    CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/CallMatch/" + CSParameters.SportEventId, data, function () {
        CompuSport.Controls.Popup.ShowWarningDialog('Match called!!');
    });
}
function ShowMatchCallCount() {
    var data = {};
    data.encounterRowId = actualEncounterInfos.EncounterRowId;
    var popup = new CompuSport.Controls.Popup();
    popup.GetAndShow({
        Url: CSParameters.RUrl + "Charts/ShowMatchCallCount/" + CSParameters.SportEventId,
        Data: data,
        PopupId: 'ShowMatchCallCount',
        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
    });
}
function ShowScanDetail() {
    var data = {};
    data.encounterRowId = actualEncounterInfos.EncounterRowId;
    var popup = new CompuSport.Controls.Popup();
    popup.GetAndShow({
        Url: CSParameters.RUrl + "Schedules/ShowScanDetail/" + CSParameters.SportEventId,
        Data: data,
        PopupId: 'ShowScanDetail',
        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
    });
}
function ScoreKeeperInfo() {
    var data = {};
    data.encounterRowId = actualEncounterInfos.EncounterRowId;
    var popup = new CompuSport.Controls.Popup();
    popup.GetAndShow({
        Url: CSParameters.RUrl + "PendingScoreSheets/ShowScoreKeeperInfo/" + CSParameters.SportEventId,
        Data: data,
        PopupId: 'ShowScoreKeeperInfo',
        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
    });
}
function GetSchedulePopup() {
    var data = {
        flowBlockId: actualEncounterInfos.FlowBlockId,
        encounterNumber: actualEncounterInfos.EncounterNumber
    };
    let popup = new CompuSport.Controls.Popup();
    popup.GetAndShow({
        PopupId: "",
        Url: CSParameters.RUrl + "Schedules/EditSchedulesFromChart/" + CSParameters.SportEventId,
        Data: data,
        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
    });
    popup.OnPosted = function (result) {
        UpdateChart(result, true);
    };
    /*
    ShowFormPopup(CSParameters.RUrl + "Schedules/EditSchedulesFromChart/" + CSParameters.SportEventId, data, null, function (result) {
        if ($('form', result).length == 0) {
            $(this).dialog('close');
            UpdateChart(result, true);
        }


    });
    */
}
var popupCreateOnTheFly;
var treeViewDivisions;
CS.FormReady(function (formId) {
    if (formId == "CreateOrUseExistingPlayer") {
        CS.off('click', '.ExistingItemCard');
        CS.on('click', '.ExistingItemCard', function (e) {
            e.preventDefault();
            var clickedTarget = $(e.target);
            var card = clickedTarget.closest('.ExistingItemCard');
            if (clickedTarget.hasClass('BtnSelect') || clickedTarget.hasClass('Prop')) {
                UpdateEncounterOpponent(card.data('id'), null, true);
                popupCreateOnTheFly.Close();
            }
        });
    }
});
function UpdateEncounterOpponent(newEntityBaseId, insertedName, skipConfirmation) {
    ResetHighlightDrawBoxes(lastHighlight);
    //Ici, je cache immédiatement la popup dans le slideup 
    //Pour etre sur que le textbox pour éditer le entity ne peut pas recaller la fonction
    entityPopup.hide();
    if (insertedName != undefined) {
        insertedName = insertedName.replace('  ', ' ').replace('\t', ' ');
    }
    else {
        insertedName = '';
    }
    var data = {};
    data.flowBlockId = actualEncounterInfos.FlowBlockId;
    data.oldEntityBaseId = actualEncounterInfos.OppIdFocus;
    data.newEntityBaseId = newEntityBaseId;
    data.encounterRowId = actualEncounterInfos.EncounterRowId;
    data.insertedName = insertedName;
    data.discriminator = actualEncounterInfos.Discriminator;
    data.drawPosition = actualEncounterInfos.DrawBoxWithFocus;
    var iFrameMode = false;
    var iFrameModePassed = $('#IFrameMode').val();
    if (iFrameModePassed != undefined) {
        iFrameMode = iFrameModePassed;
    }
    data.iFrameMode = iFrameMode;
    if (insertedName != '') {
        CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/CheckIfExistsPlayer/" + CSParameters.SportEventId, data, function (queryResult) {
            if (queryResult.noEntityExist == true) {
                if (skipConfirmation || confirm('No opponents exists on this name, do you want to create it ?')) {
                    var url = "";
                    CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/CreateEntityOnTheFly/" + CSParameters.SportEventId, data, function (queryResult) {
                        if (!IsDefined(typeof (queryResult.Success))) {
                            UpdateChart(queryResult, true);
                        }
                        else {
                            if (IsDefined(typeof (queryResult.QueryResultMsgs)) && queryResult.QueryResultMsgs.length > 0) {
                                alert(queryResult.QueryResultMsgs[0].Message);
                            }
                            else {
                                alert('Error');
                            }
                        }
                    });
                }
            }
            else {
                popupCreateOnTheFly = new CompuSport.Controls.Popup();
                popupCreateOnTheFly.Show(queryResult.PlayerSelector, { PopupId: 'ExistingPlayer' });
                popupCreateOnTheFly.OnButtonClicked = function (button, buttonValue) {
                    if (buttonValue === 'Ok') {
                        CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/CreateEntityOnTheFly/" + CSParameters.SportEventId, data, function (queryResult) {
                            if (queryResult.success != undefined && queryResult.success == false) {
                                CompuSport.Controls.Popup.ShowWarningDialog(queryResult.message);
                                //ShowConfirmDialog(queryResult.message);
                            }
                            else {
                                UpdateChart(queryResult, true);
                            }
                        });
                    }
                };
            }
        });
    }
    else {
        CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/UpdateReplaceEntity/" + CSParameters.SportEventId, data, function (queryResult) {
            if (IsDefined(typeof (queryResult.errors))) {
                alert(queryResult.errors);
            }
            else if (IsDefined(typeof (queryResult.mustRemoveLinks)) && IsDefined(typeof (queryResult.linkererror))) {
                CompuSport.Controls.Popup.ShowConfirmDialogWithResultV2('Links', queryResult.linkererror + '. Do you want to DISABLE that link and proceed with your update?', 'Yes', 'No', function (result) {
                    if (result) {
                        var url = "";
                        CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/Disablelink/" + CSParameters.SportEventId, data, function (queryResult) {
                            if (IsDefined(typeof (queryResult.Success))) {
                                CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/UpdateReplaceEntity/" + CSParameters.SportEventId, data, function (queryResult) {
                                    UpdateChart(queryResult, true);
                                });
                            }
                        });
                        CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/Disablelink/" + CSParameters.SportEventId, data, function (queryResult) {
                            if (IsDefined(typeof (queryResult.Success))) {
                                CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/UpdateReplaceEntity/" + CSParameters.SportEventId, data, function (queryResult) {
                                    UpdateChart(queryResult, true);
                                });
                            }
                        });
                    }
                });
            }
            else if (IsDefined(typeof (queryResult.noEntityExist))) {
                if (skipConfirmation || confirm('No opponents exists on this name, do you want to create it ?')) {
                    var url = "";
                    CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/CreateEntityOnTheFly/" + CSParameters.SportEventId, data, function (queryResult) {
                        if (!IsDefined(typeof (queryResult.Success))) {
                            UpdateChart(queryResult, true);
                        }
                        else {
                            if (IsDefined(typeof (queryResult.QueryResultMsgs)) && queryResult.QueryResultMsgs.length > 0) {
                                alert(queryResult.QueryResultMsgs[0].Message);
                            }
                            else {
                                alert('Error');
                            }
                        }
                    });
                }
            }
            else {
                UpdateChart(queryResult, true);
            }
        });
    }
}
function DeleteScheduleSurface(deleteOnlySurface) {
    var data = {};
    data.flowBlockId = actualEncounterInfos.FlowBlockId;
    data.encounterRowId = actualEncounterInfos.EncounterRowId;
    data.deleteOnlySurface = deleteOnlySurface;
    var iFrameMode = false;
    var iFrameModePassed = $('#IFrameMode').val();
    if (iFrameModePassed != undefined) {
        iFrameMode = iFrameModePassed;
    }
    data.iFrameMode = iFrameMode;
    CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/DeleteScheduleOrJustSurface/" + CSParameters.SportEventId, data, function (queryResult) {
        UpdateChart(queryResult, true);
    });
    //$.ajaxAntiForgery({
    //    cache: false,
    //    type: "POST",
    //    url: CSParameters.RUrl + "Charts/DeleteScheduleOrJustSurface/" + CSParameters.SportEventId,
    //    data: data,
    //    success: function (queryResult) {
    //        UpdateChart(queryResult, true);
    //    }
    //});
}
function FillUpWithRandomOpponents() {
    var round0 = $('.BB[id$="_0"]');
    $.each(round0, function (index, value) {
        var id = parseInt(value.id.replace('_0', ''), 10) + 1;
        GetEncounterInfoOfBracket(actualFlowBlockId, null, ParseDrawPosition(value.id, true), false, function (encounterInfos) {
            actualEncounterInfos = encounterInfos;
            UpdateEncounterOpponent(null, 'Team ' + id, true);
        });
    });
}

//# sourceMappingURL=EditChart.desktop.js.map
